import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, input, InputSignal, OnInit, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { MapService } from './services/map.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from '../../components/custom-route-mobile/config/constants';
import { BreakpointsService } from 'src/app/services/breakpoints.service';
import { CUSTOM_ROUTE_DESKTOP_MAP } from '../../components/custom-route-desktop/config/constants';
import { MapMarkersComponent } from './components/markers/markers.component';
import { MapPolylinesComponent } from './components/polylines/polylines.component';
import { MapProyectedPointComponent } from './components/proyected-point/proyected-point.component';
import { MapIndicationCardComponent } from './components/indication-card/indication-card.component';

import { MAP_CONFIG } from './config/constants';
import { DevPanelComponent } from './components/dev-panel/dev-panel.component';
import { MapStepNavigationComponent } from './components/step-navigation/step-navigation.component';
import { ToolsService } from 'src/app/services/tools.service';
import { IndicatorsService } from './services/indicators.service';
import { RealTimeNavigationService } from './services/real-time-navigation.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { PlannerDayStateService } from '../planner/services';
import { MakePaymentButtonComponent } from "./components/make-payment-button/make-payment-button.component";
import { RouteDataService } from './services/route-data.service';
import { StepsNavigationMapService } from './services/steps-navigation.service';
import { DebugService } from 'src/app/services/debug.service';
import { FiturMapMarkersComponent } from './components/fitur-markers/markers.component';
import { FiturMapPolylinesComponent } from './components/fitur-polylines/polylines.component';
import { RECOMMENDED_MARKER } from './components/fitur-markers/config/constants';
import { FiturMapDetailPageMarkerComponent } from './components/fitur-markers/detail-page-marker.component';
import { SendSayGoodByeEmail } from '../../components/custom-route-desktop/services';
import { CustomRouteService } from '../../services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    GoogleMapsModule,
    
    // MapMarkersComponent,
    // MapPolylinesComponent,
    FiturMapMarkersComponent,
    FiturMapPolylinesComponent,
    FiturMapDetailPageMarkerComponent,
    MapProyectedPointComponent,
    MapIndicationCardComponent,
    MapStepNavigationComponent,
    DevPanelComponent,
    // MakePaymentButtonComponent
],
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MapComponent implements OnInit {
  @ViewChild("map") map!: GoogleMap;
  
  public detailPoint: InputSignal<any> = input<any>(undefined);

  private _debugService = inject(DebugService);
  private _stepsNavigationMapService = inject(StepsNavigationMapService);
  private _routeDataService = inject(RouteDataService);
  private _mapService = inject(MapService);
  private _indicatorsService = inject(IndicatorsService)
  private _tools = inject(ToolsService);
  private _sessionStorageService = inject(SessionStorageService);
  private _breakpointsService = inject(BreakpointsService);
  private _realTimeNavigationService = inject(RealTimeNavigationService);
  private _scrollService = inject(ScrollService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  private _sendSayGoodByeEmailService = inject(SendSayGoodByeEmail);
  private _customRouteService = inject(CustomRouteService);
  
  private _routeToken = this._customRouteService.token;
  
  public showDevPanel = computed(() => this._routeDataService.showDevPanel());
  public dayToShowIndex = computed(() => this._plannerDayStateService.dayToShowIndex());

  public showStartButton = computed(() => this._routeDataService.getCurrentTrameIndex() === undefined && this._routeDataService.getCurrentStepIndex() === undefined && !this.detailPoint());
  
  private canAddMarker = computed<boolean>(() => this._realTimeNavigationService.canSetMarkerFromMap() && this._realTimeNavigationService.isFakeGPSActive())
  public options: google.maps.MapOptions = MAP_CONFIG;
  
  public recommendedMarkerOption = () => RECOMMENDED_MARKER();

  
  ngOnInit(): void {
    this._routeDataService.startInterval();
    this._tools.enabledInstallBanner.update(prev => false);

    if (this._breakpointsService.isMobile()) {
      this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.map);
    } else {
      this._sessionStorageService.setItem('customRouteDesktopViewsState', CUSTOM_ROUTE_DESKTOP_MAP.map);
    }
    
    // set isScrolled to false due to the actions affected by the scroll is only for the planner view
    this._scrollService.setIsScrolled(false);
  }

  onMapReady(gMap: any) {
    console.log("Map Ready!")
    this._mapService.initMap(gMap);
    this._stepsNavigationMapService.startStepRoute();
    this._realTimeNavigationService.isFakeGPSActive.set(false);
    this._stepsNavigationMapService.loadMapByDay();
  }

  public setLocation(event): void {
    if (!this.canAddMarker())
      return;

      if (event.latLng) {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      const markerPosition = { lat, lng };
      this._realTimeNavigationService.setLocationMarkerOnCurrentSegment(markerPosition);
    }    
  }

  public startRoute(){
    this._stepsNavigationMapService.startRoute();
  }
  
  protected saveRoute() {
    this._sendSayGoodByeEmailService.sendSayGoodByeEmail(this._routeToken()).subscribe(); // Idc the response
  }

  ngOnDestroy(): void {
    console.log("Destroying Map!")    
    this._indicatorsService.closeAll();
    this._routeDataService.stopInterval();
    this.map = null;
    this._mapService.initMap(null);
  }
}
